import { AppointmentType } from '../../models/AppointmentType';
import { Location } from '../../models/Location';
import { User } from '../../models/User';

export default class AppointmentCombos {

  static coachIsValidForType = (coach: User, type?: AppointmentType) => {
    if (!type) return true;
    return (type.coaches || []).indexOf(coach.id || 0) === -1;
  };

  static locationIsValidForCombo = (location: Location, coach?: User, type?: AppointmentType) => {
    const coachIds = (location.coaches || []).map(mm => parseInt(mm.toString(), 10));
    const invisibleCoachIds = (location.invisible_coaches || []).map(mm => parseInt(mm.toString(), 10));
    if (!!coach) {
      if (coachIds.indexOf(coach.id || 0) > -1) return false;
      if (invisibleCoachIds.indexOf(coach.id || 0) > -1) return false;
    }
    if (!!type) {
      if (!!type.is_meeting && !location.is_online) return false;
      if (!type.is_meeting && !location.is_physical) return false;
    }
    return true;
  };
}
